module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Control_Select_Dynamic_I18n', {

		configure: function(options) {
			this.registerOptions('', {
				handleWom: {
					dictionaryLoaded: {
						widget: '@root #dictionary',
						event: 'loaded',
						callback: function() {
							var visualParent = this.visualParent || this.getParent()._childrenContainerWidget;
							this.wait(visualParent, 'addedToDom').then(function() {
								if (this.getOption('loadOnActivate')) {
									this.getDataFromServer();
								} else {
									this.render();
								}
							}.bind(this));
						}
					}
				}
			});

			this.callParent('configure', arguments);
		}

	}, 'Control_Select_Dynamic');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/controls/select/dymanici18n.js
// module id = 304
// module chunks = 2